<script setup lang="ts">
import MenuItem from '@/components/FloatMenu/FloatMenuOption/indev.vue'
import IconForm from '@/components/Icon/Form/index.vue'
import { useCreateForm } from '~~/src/composables/useCreateForm'

const props = defineProps<Props>()

interface Props {
  label: string
}

defineOptions({
  name: 'CreateFormButton',
})

const { createForm, isPending } = useCreateForm()
</script>

<template>
  <MenuItem
    class="gap-3"
    @select="createForm()"
  >
    <template #icon-wrapper>
      <div class="h-7 w-7 rounded-md flex items-center justify-center overflow-hidden">
        <IconForm />
      </div>
    </template>
    <span class="font-inter font-700 text-sm leading-[22.4px]">
      {{ props.label }}
    </span>
  </MenuItem>
  <Teleport v-if="isPending" to="body">
    <div class="absolute h-100[dvh] w-100[dvh] inset-0 z-999">
      <LoadingOverlay message="Creating form..." />
    </div>
  </Teleport>
</template>
